import GameMode from "game/modes"
import ArrayHelper from "utils/ArrayHelper"

import soundSaga from "game/sound/soundSaga"

import { gameDelay } from "macguffin/Utils"

import { put, call, fork, select, take, takeEvery } from 'redux-saga/effects'
import { READY, ON_LOGIN, PLAY_REQUEST, PLAY, ON_PLAY_RESPONSE, ON_REFRESH, JACKPOT_MESSAGE_CLOSED, UPDATE_JACKPOT, SOUNDS_LOADED, ERROR, ERROR_CLOSED } from 'macguffin/redux/constants'
import { play, playDone, setPlaying, setSkipFeature, setRestoreState, setWin, setPaused, message, jackpotMessageClosed, updateStats,
    GE_RoundStarted, GE_RoundEnded, GE_FreespinStarted, GE_FreespinEnded, closeGameRound } from 'macguffin/redux/actions'
const LAST_REEL_INDEX = 4
const RESPIN_DELAY = 1000
const FREESPIN_DELAY = 1000

import {
    REEL_STOPPED,
    SPIN_COMPLETE,
    RESPIN_COMPLETE,
    WIN_COUNTUP_COMPLETE,
    WIN_ITERATION_COMPLETE,
    COMET_WILDS_MOVEMENT_COMPLETE,
    ROCKET_TAKEOFF_COMPLETE,
    PICK_ITEM,
    SET_CURRENT_PICK_RESULT_DATA,
    PICK_STAGE_COMPLETE,
    FREESPIN_COMPLETE,
    START_MARS_SEQUENCE,
    PICK_LANDING_ZONE,
    FREESPIN_SUMMARY_COMPLETE,
    BONUS_COMPLETE
} from "./constants"

import {
    setRefresh,
    setReelsConfig,
    setCurrentSpinData,
    resumeGame,
    revertGame,
    resumeSpin,
    startSpin,
    setSpinComplete,
    setRespinComplete,
    setFreespinOutcome,
    setFreespinComplete,
    startRespin,
    setRespinSummary,

    setCurrentCometWildsData,

    setCurrentWinData,
    setCurrentWinCountUp,
    setWinCountUpComplete,
    setCurrentWinIteration,

    startCountdown,
    startBonus,
    setCurrentPicksData,
    startPickStage,
    setCurrentPickResultData,
    startFreespin,
    setFreespinSummary,
    setFreespinSummaryComplete,

    setJackpot,
    startMarsSequence,
    setJackpotDraw,
} from "./actions"


import { setSpins, disableAutoPlay } from "macguffin/components/autoplay/actions"
import GameModeGroup from "../modes/GameModeGroup";

const enableSpinGroup = new GameModeGroup([GameMode.FREESPIN, GameMode.JACKPOT_DRAW])

export default function* Sagas() {
    yield takeEvery(ON_LOGIN, onLogin)
    yield takeEvery(READY, onReady)
    yield takeEvery(PLAY_REQUEST, onPlayRequest)
    yield takeEvery(ON_PLAY_RESPONSE, onPlayResponse)
    yield takeEvery(ON_REFRESH, onRefresh)
    yield takeEvery(REEL_STOPPED, onReelStopped)
    yield takeEvery(SPIN_COMPLETE, onSpinComplete)
    yield takeEvery(WIN_COUNTUP_COMPLETE, onWinCountUpComplete)
    yield takeEvery(WIN_ITERATION_COMPLETE, onWinIterationComplete)
    yield takeEvery(RESPIN_COMPLETE, onRespinComplete)
    yield takeEvery(COMET_WILDS_MOVEMENT_COMPLETE, onCometWildsComplete)
    yield takeEvery(ROCKET_TAKEOFF_COMPLETE, onRocketTakeoffComplete)
    yield takeEvery(PICK_ITEM, onItemPicked)
    yield takeEvery(SET_CURRENT_PICK_RESULT_DATA, onSetCurrentPickResultData)
    yield takeEvery(PICK_STAGE_COMPLETE, onPickStageComplete)
    yield takeEvery(FREESPIN_COMPLETE, onFreespinComplete)
    yield takeEvery(START_MARS_SEQUENCE, onStartMarsSequence)
    yield takeEvery(PICK_LANDING_ZONE, onPickLandingZone)
    yield takeEvery(BONUS_COMPLETE, onEndBonus)
    yield takeEvery(JACKPOT_MESSAGE_CLOSED, onJackpotMessageClosed)
    yield takeEvery(UPDATE_JACKPOT, onUpdateJackpot)
    yield takeEvery(FREESPIN_SUMMARY_COMPLETE, onFreespinSummaryComplete)

    yield takeEvery(SOUNDS_LOADED, onSoundsLoaded)

    yield takeEvery(ERROR, onError)
    yield takeEvery(ERROR_CLOSED, onErrorClosed)
}

function* onSoundsLoaded() {
    yield fork(soundSaga)
}

function* onJackpotMessageClosed(data) {
    const { game } = yield select()
    const { newJackpot } = data
    const { currentGameMode } = game
    yield put(setJackpot(newJackpot))

    // Revert game state after closing the popup
    if (currentGameMode === GameMode.MAIN) {
        yield put(revertGame())
    }
}

function* setNewJackpot(response) {
    if (!response) {
        return
    }

    const { game, base } = yield select()
    const { lastWin, jackpot } = response
    const { messages } = base
    let jpMessageOpen = false
    messages.forEach(m => {
        if (m.type === 'JACKPOT') {
            jpMessageOpen = true
        }
    })

    if (!jackpot) {
        return
    }

    if ((game.jackpot && game.jackpot > jackpot) || jpMessageOpen) {
        yield put(message({
            type: 'JACKPOT',
            data: { jackpot, lastWin },
            errorCode: 538,
            onClose: jackpotMessageClosed,
        }))
    } else {
        yield put(setJackpot(jackpot))
    }
}

function* onUpdateJackpot(data) {
    yield call(setNewJackpot, data.newJackpot)
}

function printSymbols(symbols) {
    console.table(Object.keys(symbols[0]).map(colNumber => symbols.map(rowNumber => rowNumber[colNumber])))
}

function fixBoosts(boostChoices) {
    let currentMultiplier = 2
    let currentWilds = 1
    let currentRemoveSymbols = 1

    boostChoices.forEach((choice) => {
        const { picks } = choice

        picks.forEach((pick) => {
            switch (pick.type) {
                case "ADD_WILDS":
                    //convert 0 wilds to the current level of wilds
                    pick.value = currentWilds
                    if (pick.picked) {
                        currentWilds++
                    }
                    break
                case "REMOVE_SYMBOL":
                    //convert 0 remove symbol to the current level of removed symbols
                    pick.value = currentRemoveSymbols
                    if (pick.picked) {
                        currentRemoveSymbols++
                    }
                    break
            }
        })
    })

    return boostChoices
}

function getScatterCount(symbols) {
    return symbols.reduce((outerSum, reel) => {
        return reel.reduce((innerSum, symbol) => {
            return innerSum + ((symbol !== "SC") ? 0 : 1)
        }, outerSum)
    }, 0)
}

function* onLogin(action) {
    // config is global and defined externally
    yield put(setReelsConfig(config.config))
}

function* enableSpin() {
    const { game } = yield select(state => state)
    const { isSpinning, currentGameMode } = game

    if (!isSpinning && !enableSpinGroup.contains(currentGameMode)) {
        yield put(GE_RoundEnded())
        yield put(playDone())
    }
}

function getRespinData(respin) {
    const {
        endStickyWilds,
        grid,
        startStickyWilds,
        stops,
        symbols,
        symbolReplacements,
        runningTotal,
        winnings
    } = respin

    return {
        endStickyWilds,
        grid,
        startStickyWilds,
        stops,
        symbols,
        symbolReplacements,
        runningTotal,
        winnings
    }
}

function getFreespinData(freespin) {
    const {
        featureExtras,
        grid,
        runningTotal,
        stops,
        symbols,
        winnings
    } = freespin

    return {
        featureExtras,
        grid,
        runningTotal,
        stops,
        symbols,
        winnings
    }
}

function getWildsData(spinData) {
    const { endStickyWilds = [], startStickyWilds = [] } = spinData
    return { endStickyWilds, startStickyWilds }
}

function* onRefresh(action) {
    const { session } = yield select(state => state)
    const { restoreState = {} } = session
    const { currentRespinIndex, currentFreespinIndex } = restoreState

    console.log(action)
    yield put(setRefresh(true))

    const { response } = action
    const {
        freespins,
        grid,
        respins,
        stops,
        symbolReplacements,
        symbols,
        ended
    } = response

    yield call(setNewJackpot, response)

    let currentSpinData = {
        grid,
        stops,
        symbols,
        symbolReplacements
    }

    const respinsArray = ArrayHelper(respins)
    const freespinsArray = ArrayHelper(freespins)

    if (respinsArray.isNotEmpty() && (isNaN(currentRespinIndex) || currentRespinIndex >= respinsArray.lastIndex())) {
        currentSpinData = getRespinData(respinsArray.last())
    }

    if (freespinsArray.isNotEmpty() && (ended || currentFreespinIndex >= freespinsArray.lastIndex())) {
        currentSpinData = freespins.length ? getFreespinData(freespinsArray.last()) : getRespinData(respinsArray.last())
    }

    yield put(setCurrentSpinData(currentSpinData))
    printSymbols(currentSpinData.symbols)

    if(freespins) {
        yield put(GE_FreespinStarted(freespins.length))
    }
    

    yield put(resumeGame())
}

function* onReady() {
    const { base, session } = yield select(state => state)
    const { response } = base
    const { restoreState = {} } = session
    const { freespins, respins, boostChoices, ended, pickChoices, jackpotDraw, availableAction, symbols } = response
    
    const { currentRespinIndex, currentFreespinIndex, reachedMars } = restoreState
    console.log(restoreState, currentRespinIndex, currentFreespinIndex)

    if (jackpotDraw) {
        console.log("JOURNEY COMPLETED")
        yield put(setPlaying(false))
        return
    }

    const totalWin = yield getTotalWin()

    yield put(setPlaying(true))

    if (respins && !isNaN(currentRespinIndex) && (currentRespinIndex < ArrayHelper(respins).lastIndex())) {
        console.log(`RESUME RESPIN ${currentRespinIndex + 1} of ${respins.length}`)
        const currentRespin = currentRespinIndex >= 0 ? getRespinData(respins[currentRespinIndex]) : getRespinData(response)
        printSymbols(currentRespin.symbols)

        const nextRespin = getRespinData(respins[currentRespinIndex + 1])
        const wildsData = getWildsData(nextRespin)

        let currentFreespins = getScatterCount(symbols)

        for (let i = 0, l = currentRespinIndex + 1; i < l; i ++) {
            currentFreespins += getScatterCount(respins[i].symbols)
        }

        yield put(setWin(totalWin))
        yield put(resumeSpin({ currentRespinIndex, currentFreespins }))
        yield put(setCurrentCometWildsData(wildsData))
        yield onCometWildsComplete()
        return
    }

    if (boostChoices) {
        if (!freespins.length || currentFreespinIndex === ArrayHelper(freespins).lastIndex() && !ended) {
            console.log("RESUME PICK!")

            const lastChoice = ArrayHelper(boostChoices).last()
            yield put(setCurrentPicksData(pickChoices, fixBoosts(boostChoices)))
            yield put(setWin(totalWin))

            yield put(startPickStage(boostChoices.length))
            return
        } else if (!isNaN(currentFreespinIndex)) {
            console.log(`RESUME FREESPIN ${currentFreespinIndex + 1} of ${freespins.length}`)

            const lastChoice = ArrayHelper(boostChoices).last()
            yield put(setCurrentPicksData(pickChoices, fixBoosts(boostChoices)))
            yield put(setWin(totalWin))

            const currentFreespin = getFreespinData(freespins[currentFreespinIndex])
            printSymbols(currentFreespin.symbols)

            const { featureExtras: { meterPosition, spinsLeft }} = currentFreespin
            const currentPickStageIndex = boostChoices.length - 1

            const resumeData = {
                currentFreespinIndex,
                currentPickStageIndex,
                meterPosition,
                currentFreespins: spinsLeft
            }

            yield put(resumeSpin(resumeData))
            yield put(startFreespin(currentFreespinIndex))
            yield spinReels(currentFreespin)
            return
        }
    }

    if (availableAction === "finish" && !ended) {
        console.log("RESUME MARS")
        const freespinsArray = ArrayHelper(freespins)
        const { featureExtras: { meterPosition, spinsLeft }} = freespinsArray.last()

        const resumeData = {
            meterPosition,
            currentFreespins: spinsLeft
        }

        yield put(setWin(totalWin))
        yield put(resumeSpin(resumeData))
        yield put(startMarsSequence())
        return
    }

    console.log("RESUME NORMALLY")
    yield put(setPlaying(false))
}

function* onPlayRequest(action) {
    const { params } = action

    const { game } = yield select(state => state)
    const { jackpot } = game

    yield put(setWin(0))
    yield put(startSpin())

    if (jackpot) {
        yield put(play({...params, expectedJackpot: jackpot}))
    } else {
        yield put(play(params))
    }
}

function* onPlayResponse(action) {
    if (!action.response) {
        yield put(setPlaying(false))
        return
    }

    console.log(action)
    if (action.response.symbols) {
      printSymbols(action.response.symbols)
    }

    const { game } = yield select(state => state)
    const { response } = action

    const { stats } = response
    yield put(setPlaying(false))
    yield put(updateStats(stats))
    yield put(setPlaying(true))

    const res = (!response || response.errorCode) ? {} : response
    const {
        boostChoices,
        pickChoices,
        endStickyWilds,
        grid = 'baseReels',
        jackpot,
        jackpotDraw,
        respins,
        stops = [ 0, 0, 0, 0, 0 ],
        symbolReplacements,
        symbols = game.currentSpinData.symbols,
        win,
        winnings = []
    } = res

    yield put(setRefresh(false))

    if (jackpotDraw) {
        yield put(setJackpot(jackpot))
        yield put(setJackpotDraw(jackpotDraw))
        return
    }

    yield call(setNewJackpot, res)

    if (ArrayHelper(boostChoices).isNotEmpty()) {
        // if we haven't done it already, set up the pick data
        if (!game.boostChoices || !game.boostChoices.length) {
            yield put(setCurrentPickResultData(fixBoosts(response.boostChoices)))
            return
        }
    }

    const currentSpinData = {
        boostChoices,
        pickChoices,
        endStickyWilds,
        grid,
        jackpot,
        respins,
        stops,
        symbolReplacements,
        symbols,
        win,
        winnings
    }

    yield put(GE_RoundStarted(response.ba))
    yield spinReels(currentSpinData)
}

function* spinReels(spinData) {
    const { base, game } = yield select(state => state)
    const { response } = base
    const { respins, freespins } = response

    const { currentRespinIndex, currentFreespinIndex } = game
    yield put(setRestoreState({ currentRespinIndex, currentFreespinIndex }))
    yield put(setCurrentSpinData(spinData))
    yield gameDelay(350)
    yield put(setSkipFeature(false))
}

function* onReelStopped() {
    const { game } = yield select(state => state)
    const { currentGameMode, reelStoppedIndex, currentSpinData } = game
    const { winnings } = currentSpinData

    if (reelStoppedIndex === LAST_REEL_INDEX) {
        switch(currentGameMode) {
            case GameMode.REVERT:
                yield put(setPlaying(false))
                break
            case GameMode.RESPIN:
                yield put(setRespinComplete())
                break
            case GameMode.FREESPIN:
                yield put(setFreespinComplete())
                break
            case GameMode.MAIN:
            default:
                yield put(setSpinComplete())
                break
        }
    }
}

function* onSpinComplete() {
    const { base, game } = yield select(state => state)
    const { response } = base
    const { currentRespinIndex = -1, currentSpinData } = game
    const { respins, winnings, ba, win } = response

    if (respins) {
        yield put(setRestoreState({ currentRespinIndex }))
    }

    if (ArrayHelper(winnings).isNotEmpty() && win > ba) {
        yield startWinSequence(currentSpinData)
        return
    }

    if (ArrayHelper(respins).isNotEmpty()) {
        yield startRespins()
        return
    }

    if (response.pickChoices) {
        yield startBonusGame()
        return
    }

    yield enableSpin()
}

function* startWinSequence(currentSpinData) {
    const { winnings, win } = currentSpinData

    const totalWin = winnings.reduce((accumulator, current) => {
        return accumulator + current[2]
    }, 0)

    if (totalWin) {
        yield put(setCurrentWinData(winnings, win))
        yield put(setCurrentWinCountUp(totalWin))
    } else {
        yield put(setWinCountUpComplete())
    }
}

function* onWinCountUpComplete() {
    const totalWin = yield getTotalWin()

    yield put(setWin(totalWin))

    if (totalWin) {
        yield gameDelay(1000)
    }

    yield put(setCurrentWinCountUp())
    yield winSequenceComplete()
}

function* getTotalWin() {
    
    const { base, game, session } = yield select(state => state)
    const { response } = base
    const { winnings = [], respins, freespins, jackpotDraw } = response
    const { restoreState = {} } = session

    const {
        currentRespinIndex = restoreState && restoreState.currentRespinIndex,
        currentFreespinIndex = restoreState && restoreState.currentFreespinIndex
    } = game

    const respinsArray = ArrayHelper(respins)
    const freespinsArray = ArrayHelper(freespins)

    const collectedWinnings = [ winnings ]

    if (respinsArray.isNotEmpty()) {
        for (let i = 0; i < currentRespinIndex + 1; i++) {
            const respin = respins[i]
            collectedWinnings.push(respin.winnings)
        }
    }

    if (freespinsArray.isNotEmpty()) {
        for (let i = 0; i < currentFreespinIndex + 1; i++) {
            const freespin = freespins[i]
            collectedWinnings.push(freespin.winnings)
        }
    }

    let totalWin = collectedWinnings.reduce((outerSum, currentWinning) => {
        return currentWinning.reduce((innerSum, currentWin) => {
            return innerSum + currentWin[2]
        }, outerSum)
    }, 0)

    if (jackpotDraw) {
        const { jackpotWin, fuelWin, finalStageWin } = jackpotDraw
        totalWin += jackpotWin
        totalWin += fuelWin
        totalWin += finalStageWin
    }

    return totalWin
}

function* winSequenceComplete() {
    const { base, game } = yield select(state => state)
    const { playing, response } = base
    const { boostChoices, freespins, pickChoices, respins, win, availableAction } = response

    const {
        currentSpinData,
        currentFreespinIndex,
        currentPickStageIndex,
        currentRespinIndex,
        respinSummary,
        freespinSummary,
        freespinSummaryComplete
    } = game

    const { endStickyWilds } = currentSpinData

    //if we're in respins, continue respinning
    if (ArrayHelper(endStickyWilds).isNotEmpty()) {
        yield startRespins()
        return
    }

    //if we're in freespins
    const nextFreespinIndex = currentFreespinIndex + 1
    if (ArrayHelper(freespins).isNotEmpty() && ArrayHelper(freespins).isNotLastIndex(nextFreespinIndex)) {
        yield startFreespins()
        return
    }

    //if we're entering the first pick stage
    if (pickChoices) {
        const nextPickStageIndex = currentPickStageIndex + 1
        if (ArrayHelper(boostChoices).isEmpty()) {
            yield startBonusGame()
        } else {
            yield put(setCurrentPicksData(pickChoices))
            yield put(startPickStage(nextPickStageIndex))
        }
        return
    }

    //if we"ve run out of freespins
    if (ArrayHelper(freespins).isLastIndex(currentFreespinIndex)) {

        //the player has finally reached Mars
        if (availableAction === "finish") {
            yield put(startMarsSequence())
            return
        }

        //show the freespin summary
        if (!freespinSummary) {
            yield showFreespinSummary(win)
            return
        }
        if (!freespinSummaryComplete) {
            yield put(setFreespinSummaryComplete());
        }
    } else if (ArrayHelper(respins).isLastIndex(currentRespinIndex)) {
        //show the respin summary if there are no more respins left
        if (!respinSummary) {
            yield showRespinSummary(win)
            return
        }
    }

    yield startWinIterations()
    yield enableSpin()
}

function* startWinIterations() {
    const { autoplay = {}, base, game } = yield select(state => state)
    const { response } = base
    const { freespins, respins } = response
    const { currentWinData, currentFreespinIndex, currentRespinIndex } = game

    if (!currentWinData) {
        return
    }

    const noAutoplayRemaining = !autoplay.spinsLeft
    const noRespinsRemaining = (!respins || ArrayHelper(respins).isLastIndex(currentRespinIndex))
    const noFreespinsRemaining = (!freespins || ArrayHelper(freespins).isLastIndex(currentFreespinIndex))

    if (noAutoplayRemaining && noRespinsRemaining && noFreespinsRemaining) {
        yield put(setCurrentWinIteration(0))
    }
}

function* onWinIterationComplete() {
    const { game } = yield select(state => state)
    const { currentWinData, currentWinIteration } = game

    if (!isNaN(currentWinIteration) && currentWinData && currentWinData.length > 1) {
        const nextWinIteration = (currentWinIteration + 1) % currentWinData.length
        yield put(setCurrentWinIteration(nextWinIteration))
    }
}

function* showRespinSummary(win) {
    yield put(setRespinSummary())

    if (win) {
        yield gameDelay(500)
        yield put(setCurrentWinCountUp(win))
    } else {
        yield put(setWinCountUpComplete())
        yield gameDelay(1000)
        yield enableSpin()
    }
}

function* showFreespinSummary(win) {
    yield put(setFreespinSummary())

    if (win) {
        yield gameDelay(500)
        yield put(setCurrentWinCountUp(win))
    } else {
        yield put(setWinCountUpComplete())
    }
}

function* startRespins() {
    const { base, game } = yield select(state => state)
    const { response, win } = base
    const { respins} = response
    const { currentRespinIndex = -1, currentSpinData } = game
    const nextRespinIndex = currentRespinIndex + 1

    if (respins[nextRespinIndex]) {
        const { endStickyWilds = [], startStickyWilds = [] } = respins[nextRespinIndex]
        //if we have new wilds appear on the reel, give them time to play their animations before continuing
        const endLength = currentSpinData.endStickyWilds && currentSpinData.endStickyWilds.length || 0
        const startLength = currentSpinData.startStickyWilds && currentSpinData.startStickyWilds.length || 0

        if (endLength > startLength) {
            yield gameDelay(1000)
        }

        yield put(setCurrentCometWildsData({ endStickyWilds, startStickyWilds }))
    }
}

function* onCometWildsComplete() {
    const { base, game } = yield select(state => state)
    const { response } = base
    const { respins } = response
    const { currentRespinIndex = -1 } = game

    const nextRespinIndex = currentRespinIndex + 1

    if (!respins[nextRespinIndex]) {
        yield onRespinComplete()
        return
    }

    const nextRespin = respins[nextRespinIndex]
    const currentSpinData = getRespinData(nextRespin)

    console.log("ON RESPIN " + (nextRespinIndex + 1) + " OF " + respins.length)
    printSymbols(currentSpinData.symbols)
    yield put(startRespin(nextRespinIndex))
    yield spinReels(currentSpinData)
}

function* onRespinComplete() {
    const { base, game } = yield select(state => state)
    const { response } = base
    const { pickChoices, respins, win = 0 } = response
    const { currentSpinData, currentRespinIndex } = game
    const { winnings, runningTotal } = currentSpinData

    //show the winnings if we have them
    if (ArrayHelper(winnings).isNotEmpty()) {
        yield startWinSequence(currentSpinData)
        return
    }

    //continue with the respins
    const nextRespinIndex = currentRespinIndex + 1
    if (ArrayHelper(respins).isNotLastIndex(nextRespinIndex)) {
        yield gameDelay(1000)
        yield startRespins()
        return
    }

    //if we"ve triggered freespins, start the bonus sequence
    if (pickChoices) {
        yield startBonusGame()
        return
    }

    //show the final results of the respins
    yield showRespinSummary(win)
}

function* startBonusGame() {
    yield put(setRestoreState({ currentFreespinIndex: -1 }))
    yield put(setPlaying(true))
    yield put(disableAutoPlay(true))
    yield put(setSpins(0))
    yield gameDelay(2000)

    const { soundAvailable, soundsLoaded } = yield select(state => state.base)
    yield put(startCountdown())

    if (!soundAvailable || !soundsLoaded) {
        yield gameDelay(6000)
        yield put(startBonus())
    }
}

function* onRocketTakeoffComplete() {
    const { base } = yield select(state => state)
    const { response } = base
    const { pickChoices, freespins } = response

    yield put(setCurrentPicksData(pickChoices))
    yield put(startPickStage(0))

    yield put(GE_FreespinStarted(freespins.length))
}

function* onItemPicked(action) {
    const { pickIndex } = action

    yield put(play({ ga: 'makePick', pick: pickIndex + 1 }))
}

function* onSetCurrentPickResultData(action) {
    const { currentPickResultData } = action
    const lastChoice = ArrayHelper(currentPickResultData).last()
    const { featureExtras } = lastChoice || {}
    const { spinsPlayed = 0 } = featureExtras || {}
    yield put(setRestoreState({ currentFreespinIndex: spinsPlayed }))
}

function* onPickStageComplete() {
    const { base, game } = yield select(state => state)
    const { response } = base
    const { freespins, win } = response
    const { currentFreespinIndex } = game

    const nextFreespinIndex = currentFreespinIndex + 1

    if (ArrayHelper(freespins).isNotLastIndex(nextFreespinIndex)) {

        if (!currentFreespinIndex) {
            yield gameDelay(2000)
        } else {
            yield gameDelay(1000)
        }

        yield startFreespins()
        return
    }

    yield showFreespinSummary(win)
}

function* startFreespins() {
    const { base, game } = yield select(state => state)
    const { response, win } = base
    const { freespins } = response
    const { currentFreespinIndex = -1 } = game

    const nextFreespinIndex = currentFreespinIndex + 1

    const nextFreespin  = freespins[nextFreespinIndex]
    const currentSpinData = getFreespinData(nextFreespin)

    console.log("ON FREESPIN " + (nextFreespinIndex + 1) + " OF " + freespins.length)
    printSymbols(currentSpinData.symbols)

    yield put(startFreespin(nextFreespinIndex))
    yield spinReels(currentSpinData)
}

function* onFreespinComplete() {
    const { base, game } = yield select(state => state)
    const { response } = base
    const { freespins, pickChoices, win, availableAction } = response
    const { currentSpinData, currentFreespinIndex, currentPickStageIndex } = game
    const { winnings, runningTotal } = currentSpinData

    //show the winnings if we have any
    if (ArrayHelper(winnings).isNotEmpty()) {
        yield startWinSequence(currentSpinData)
        return
    }

    //continue with the freespins
    const nextFreespinIndex = currentFreespinIndex + 1
    if (ArrayHelper(freespins).isNotLastIndex(nextFreespinIndex)) {
        yield gameDelay(500)
        yield startFreespins()
        return
    }

    //if we're at the next pick stage
    if (ArrayHelper(pickChoices).isNotEmpty()) {
        const nextPickStageIndex = currentPickStageIndex + 1
        yield put(setCurrentPicksData(pickChoices))
        yield put(startPickStage(nextPickStageIndex))
        return
    }

    //if the player has reached Mars and the final choice
    if (availableAction === "finish") {
        yield put(startMarsSequence())
        return
    } else {
        //show the final results of the freespins
        yield showFreespinSummary(win)
    }
}

function* onStartMarsSequence() {
    yield put(setRestoreState({ reachedMars: true }))
}

function* onPickLandingZone() {
    const totalWin = yield getTotalWin()
    yield put({
        type: PLAY,
        params: {ga: "finish"}
    })
    yield put(setWin(totalWin))
}

function* onFreespinSummaryComplete() {
    const totalWin = yield getTotalWin()
    yield put(setWin(totalWin))
    yield put(closeGameRound())
}

function* onEndBonus() {
    const { base } = yield select(state => state)
    const { response } = base
    yield put(GE_FreespinEnded(response.freespins.length))

    //return to allowing the player to spin
    yield put(setRestoreState({}))
    yield put(disableAutoPlay(false))
    yield enableSpin()
}

let previousError
function* onError(action) {
    const { error } = action
    previousError = error
}

function* onErrorClosed() {
    if (previousError.errorCode === 520) {
        window.location = window.location
        return
    }

    yield put(revertGame())
}

